import { api } from "./api";
import { ICommissionRequest, CommissionRequestStatus } from "../types/commissionRequest.type";

export const commissionRequestApi = {
  // Получение всех запросов на комиссию
  getCommissionRequests: async (params?: {
    page?: number;
    limit?: number;
    status?: CommissionRequestStatus;
    salesUserId?: string;
    startDate?: string;
    endDate?: string;
    search?: string;
  }) => {
    const response = await api.get("/commission-request", { params });
    return response.data;
  },

  // Получение одного запроса по ID
  getCommissionRequestById: async (id: string) => {
    const response = await api.get(`/commission-request/${id}`);
    return response.data;
  },

  // Одобрение запроса на комиссию
  approveCommissionRequest: async (id: string, data?: { notes?: string }) => {
    const response = await api.put(`/commission-request/${id}/approve`, data);
    return response.data;
  },

  // Отклонение запроса на комиссию
  rejectCommissionRequest: async (data: {
    id: string;
    rejectionReason: string;
    notes?: string;
  }) => {
    const response = await api.put(`/commission-request/${data.id}/reject`, {
      rejectionReason: data.rejectionReason,
      notes: data.notes,
    });
    return response.data;
  },

  // Удаление запроса на комиссию
  deleteCommissionRequest: async (id: string) => {
    const response = await api.delete(`/commission-request/${id}`);
    return response.data;
  },
};

